import React, { useState } from 'react';
import Bg from '../../../images/shapes/shape_title_under_line.svg'
import shape1 from '../../../images/shapes/shape_space_4.svg'
import shape2 from '../../../images/shapes/shape_angle_3.webp'

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';

const faqItems = [
    {
        id: '1',
        question: 'Q. What services does Krit Cloud Platforms provide?',
        answer: 'Krit Cloud Platforms Sdn Bhd helps businesses plan, build and support practical digital solutions. Our work covers software development, website and web application development, cloud solutions, business automation, data reporting and IT consulting.',
        points: ['Custom software and web applications', 'Cloud migration and infrastructure setup', 'Business automation and system integration', 'IT consulting, maintenance and support'],
    },
    {
        id: '2',
        question: 'Q. How do you start a new IT project?',
        answer: 'We begin with a discovery session to understand your business goals, current systems, users, budget range and timeline. From there, we recommend a clear project scope, delivery approach and next steps before development begins.',
        points: ['Requirement discovery and workflow review', 'Scope, timeline and priority planning', 'Technical risk and integration checks', 'Clear proposal before implementation'],
    },
    {
        id: '3',
        question: 'Q. Can you improve or maintain an existing system?',
        answer: 'Yes. We can review existing websites, applications, databases or cloud environments and help with fixes, performance improvements, security hardening, modernization and ongoing maintenance.',
        points: ['Application health checks', 'Bug fixes and feature enhancements', 'Legacy system modernization', 'Monitoring and support planning'],
    },
    {
        id: '4',
        question: 'Q. Do you build solutions for specific business workflows?',
        answer: 'Yes. We design solutions around the way your team actually works. This can include internal portals, CRM workflows, reporting dashboards, approval flows, customer platforms, APIs and automated document processes.',
        points: ['Workflow and user journey mapping', 'Role-based portals and dashboards', 'API and database integration', 'Automation for repetitive tasks'],
    },
    {
        id: '5',
        question: 'Q. What support is available after launch?',
        answer: 'After launch, we can provide technical support, updates, monitoring, troubleshooting and continuous improvement. The goal is to keep your solution stable, secure and useful as your business grows.',
        points: ['Post-launch troubleshooting', 'Performance and security updates', 'User feedback improvements', 'Long-term technical advisory'],
    },
];

const FaqSection = () => {

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <section className="faq_section section_decoration">
            <div className="container">
                <div className="heading_block text-center">
                    <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
                        F.A.Q.
                    </div>
                    <h2 className="heading_text mb-0">
                        Need <mark>Support?</mark>
                    </h2>
                </div>

                <div className="faq_accordion accordion" id="faq_accordion">
                    <Accordion open={open} toggle={toggle} className="accordion" id="service_process_faq">
                        {faqItems.map((faq) => (
                            <AccordionItem className="accordion-item" key={faq.id}>
                                <AccordionHeader targetId={faq.id}>
                                    {faq.question}
                                </AccordionHeader>
                                <AccordionBody accordionId={faq.id} className='acc_body'>
                                    <div className="text_a">A.</div>
                                    <p>{faq.answer}</p>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <ul className="icon_list unordered_list_block">
                                                {faq.points.slice(0, 2).map((point, item) => (
                                                    <li key={item}>
                                                        <span className="icon_list_icon">
                                                            <i className="fa-solid fa-circle fa-fw"></i>
                                                        </span>
                                                        <span className="icon_list_text">
                                                            {point}
                                                        </span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div className="col-md-6">
                                            <ul className="icon_list unordered_list_block">
                                                {faq.points.slice(2).map((point, item) => (
                                                    <li key={item}>
                                                        <span className="icon_list_icon">
                                                            <i className="fa-solid fa-circle fa-fw"></i>
                                                        </span>
                                                        <span className="icon_list_text">
                                                            {point}
                                                        </span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </AccordionBody>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </div>
            <div className="decoration_item shape_image_1">
                <img src={shape1} alt="Krit Shape" />
            </div>
            <div className="decoration_item shape_image_2">
                <img src={shape2} alt="Krit Shape Angle" />
            </div>
        </section>
    )
};
export default FaqSection;
